import { createContext, useContext } from "react";
const FormViewContext = createContext(void 0);
function useFieldView(fieldId) {
  const context = useFormView();
  const fieldView = context.fields.find((field) => field.id === fieldId);
  return fieldView;
}
function useFormView() {
  const context = useContext(FormViewContext);
  if (context === void 0) {
    throw new Error("useFormView must be used within a FormViewProvider");
  }
  return context;
}
export {
  FormViewContext,
  useFieldView,
  useFormView
};
//# sourceMappingURL=form-view-context.js.map
